import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import TablaObs from './TablaObservaciones';

import {
    renderDayPickerB,
    renderTextArea
} from "../../Utils/renderField/renderField";

function ObservacionesForm(props) {
    const { registroObservacion, detalleObs } = props;
    
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div>
            <div className='row mb-2'>
                <div className='col-2'>
                    <Field
                        name="fecha"
                        component={renderDayPickerB}
                        msj="Fecha"
                    />
                </div>
                <div className='col-10'>
                    <Field
                        name="observacion"
                        placeholder="Limitación"
                        className="form-control"
                        component={renderTextArea}
                        msj="Observaciones"
                    />
                </div>
            </div>
            <div className='d-flex flex-row mt-3'>
                <button
                    className='btn mr-2 mb-3 btn-primary'
                    onClick={() => {registroObservacion(id_emp[7]);}}
                >
                    Guardar
                </button>
                <a
                    href={`/#/registro_marca/${id_emp[5]}/marca`}
                    className='btn btn-secondary mb-3'
                >
                    Regresar
                </a>
            </div>
            <div>
                <TablaObs
                    detalle={detalleObs}
                />
            </div>
            <br />
            <br />
        </div>
    );
}

ObservacionesForm.propTypes = {
    modulo: PropTypes.object,
};

export default reduxForm({
    form: 'FormObservacionRM',
})(ObservacionesForm);
